import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["textToken", "textTokenArgs"],
  _excluded2 = ["textToken", "textTokenArgs", "numberOfLines", "widthArray"];
import { Box } from '@bubble-ui/layout-box';
import { useDesignContext } from '@klarna/designtokens';
import * as React from 'react';
import { defaultComponentTokens } from './defaultComponentTokens';
var defaultWidthArray = ['100%', '80%', '70%', '85%'];
var SingleLine = _ref => {
  var {
      textToken,
      textTokenArgs
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var designContext = useDesignContext(defaultComponentTokens);
  if (!designContext.hasTokenInContext(textToken)) {
    return null;
  }
  var {
    lineHeight
  } = designContext.get(textToken, textTokenArgs);
  var marginVertical = lineHeight * 0.1;
  var height = lineHeight - marginVertical * 2;
  return /*#__PURE__*/React.createElement(Box.Skeleton, _extends({
    height: height,
    marginTop: marginVertical,
    marginBottom: marginVertical,
    borderRadius: "corner-radius/round"
  }, props));
};
export var TypographySkeleton = _ref2 => {
  var {
      textToken = 'typography/text-style',
      textTokenArgs,
      numberOfLines = 1,
      widthArray = defaultWidthArray
    } = _ref2,
    boxSkeletonProps = _objectWithoutProperties(_ref2, _excluded2);
  if (numberOfLines === 1) {
    return /*#__PURE__*/React.createElement(SingleLine, _extends({
      textToken: textToken,
      textTokenArgs: textTokenArgs,
      width: widthArray[0]
    }, boxSkeletonProps));
  }
  var lines = Array.from({
    length: numberOfLines
  });
  return /*#__PURE__*/React.createElement(Box, null, lines.map((_, index) => {
    return /*#__PURE__*/React.createElement(SingleLine, _extends({
      key: index,
      textToken: textToken,
      textTokenArgs: textTokenArgs,
      width: widthArray[index % widthArray.length]
    }, boxSkeletonProps));
  }));
};
TypographySkeleton.displayName = 'Typography.Skeleton';
//# sourceMappingURL=Skeleton.js.map